/** @format */

import React, { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import flat from "flat";
import { BeatLoader } from "react-spinners";
import { loadingStates, validateEmail } from "../../utilities/utilities";
import colors from "../../utilities/design";
import { showNotification } from "@mantine/notifications";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getPartiesList,
  getWorkSpaceLists,
} from "../../utilities/apis/parties";
import AgreementParty from "./AgreementParty";
import userPartyCreateHook from "../../hooks/usePartyCreate";
import { useNavigate } from "react-router-dom";
import {
  getAgreementDetails,
  putflowJson,
} from "../../utilities/apis/agreements";
import {
  getBuDetails,
  getOrgDetailsFromMaster,
} from "../../utilities/apis/users";
import { Group, ThemeIcon, Title, Text, Divider } from "@mantine/core";

import { IconUsers } from "@tabler/icons-react";

const AgreementForm3 = ({
  flowData,
  setFlowData,
  id,
  form,
  setUiConfigs,
  uiConfigs,
  save,
  initialState,
  actionText,
}) => {
  const agreementFormJson = flat.unflatten(form.values);
  // console.log("agreementformjson: ", agreementFormJson);
  // console.log({ agreementFormJson });
  const [dropDownNames, setDropDownNames] = useState([]);
  const [dataRole, setDataRole] = useState(flowData || {});
  const [parties, setParties] = useState([]);
  const [addParty, setAddParty] = useState(2);
  const array = [
    "firstParty",
    "secondParty",
    "thirdParty",
    "fourthParty",
    "fifthParty",
    "sixthParty",
    "seventhParty",
    "eighthParty",
    "ninthParty",
    "tenthParty",
    "eleventhParty",
    "twelthParty",
    "thirteenthParty",
    "fourteenthParty",
    "fifteenthParty",
    "sixteenthParty",
    "seventeenthParty",
    "eighteenthParty",
    "nineteenthParty",
    "twentythParty",
  ];
  // const[name, setName]= useState("");

  userPartyCreateHook("firstParty", form, parties, initialState);
  userPartyCreateHook("secondParty", form, parties, initialState);
  userPartyCreateHook("thirdParty", form, parties, initialState);
  userPartyCreateHook("fourthParty", form, parties, initialState);
  userPartyCreateHook("fifthParty", form, parties, initialState);
  userPartyCreateHook("sixthParty", form, parties, initialState);
  userPartyCreateHook("seventhParty", form, parties, initialState);
  userPartyCreateHook("eighthParty", form, parties, initialState);
  userPartyCreateHook("ninthParty", form, parties, initialState);
  userPartyCreateHook("tenthParty", form, parties, initialState);
  userPartyCreateHook("eleventhParty", form, parties, initialState);
  userPartyCreateHook("twelthParty", form, parties, initialState);
  userPartyCreateHook("thirteenthParty", form, parties, initialState);
  userPartyCreateHook("fourteenthParty", form, parties, initialState);
  userPartyCreateHook("fifteenthParty", form, parties, initialState);
  userPartyCreateHook("sixteenthParty", form, parties, initialState);
  userPartyCreateHook("seventeenthParty", form, parties, initialState);
  userPartyCreateHook("eighteenthParty", form, parties, initialState);
  userPartyCreateHook("nineteenthParty", form, parties, initialState);
  userPartyCreateHook("twentythParty", form, parties, initialState);

  const partiesApi = async (name) => {
    const { data: res } = await apiWrapWithErrorWithData(
      getPartiesList({ name }),
    );
    setParties(res);
    const names = res.map(({ name: val }) => val);
    console.log("response for parties: ", res);
    setDropDownNames(names);
  };
  console.log(dropDownNames);
  useEffect(() => {
    for (let i = 20; i >= 1; i--) {
      const partyName = array[i - 1];
      if (
        agreementFormJson[partyName] &&
        Object.keys(agreementFormJson[partyName]).length
      ) {
        setAddParty(i);
        break; // Exit loop once the largest party number with data is found
      }
    }
    partiesApi();
  }, []);
  // console.log(addParty);
  const validate = () => {
    form.clearErrors();

    const keys = {};

    const validateParty = (party) => {
      if (!party) return;

      if (
        party.data.type === "Entity" &&
        (!party.data.name || party.data.name.length < 3)
      ) {
        keys[`${party.name}.name`] = "Enter at least 3 characters.";
      }

      // Only check signatory for first party
      if (
        party.name === "firstParty" &&
        (!dataRole["7"] ||
          dataRole["7"].length === 0 ||
          !dataRole["7"][0]?.userId)
      ) {
        keys[`firstParty.signingAuthority`] =
          "Please select the signing authority.";
      }
      if (
        party.data.type === "Entity" &&
        (!party.data.entityType || party.data.entityType.length < 3)
      ) {
        keys[`${party.name}.entityType`] = "Please select an entity type.";
      }

      if (
        party.data.type === "Individual" &&
        (!party.data.indi_name || party.data.indi_name.length < 3)
      ) {
        keys[`${party.name}.indi_name`] = "Enter at least 3 characters.";
      }

      if (
        party.data.type === "Individual" &&
        !validateEmail(party.data.indi_email)
      ) {
        keys[`${party.name}.indi_email`] = "Enter a valid email address.";
      }
      // if(! party.data.brandName ){
      //   keys[`${party.name}.brandName`]="please enter brand name.";
      // }
    };

    // let parties = [agreementFormJson.firstParty, agreementFormJson.secondParty];
    const parties = [
      { data: agreementFormJson.firstParty, name: "firstParty" },
      { data: agreementFormJson.secondParty, name: "secondParty" },
    ];

    for (let i = 3; i <= Math.min(addParty, 20); i++) {
      const partyName = array[i - 1]; // Get the corresponding party name from the array
      parties.push({
        data: agreementFormJson[partyName],
        name: `${partyName}`,
      });
    }
    // parties =  [...new Set(parties)];
    parties.forEach((party, index) => validateParty(party, index));

    if (Object.keys(keys).length !== 0) {
      form.setErrors(keys);
      showNotification({
        color: "red",
        title: "Validation Error",
        message: "Please complete all mandatory fields before continuing.",
        autoClose: 3000,
      });
    }

    return Object.keys(keys).length === 0;
  };
  useEffect(() => {
    const fetchData = async () => {
      const agreementId = id;
      const data = await apiWrapWithErrorWithData(
        getAgreementDetails({ agreementId }),
      );
      const fetchedDataRole = data.agreement?.flowJson;
      if (fetchedDataRole) {
        setDataRole(fetchedDataRole);
      }
    };

    fetchData();
  }, []);
  const savePrev = async () => {
    setUiConfigs({
      ...uiConfigs,
      currentStep: 1,
    });
  };
  const navigate = useNavigate();
  const saveNext = async () => {
    if (validate()) {
      setFlowData(dataRole);
      await save({ ...form.values, formCompleted: true });
      setUiConfigs({
        ...uiConfigs,
        currentStep: 3,
      });
    }
  };

  useEffect(() => {
    const getfirstPartyDetails = async () => {
      const response_BU = await apiWrapWithErrorWithData(
        getBuDetails({ id: parseInt(form.businessUnit) }),
      );
      const response = await apiWrapWithErrorWithData(
        getOrgDetailsFromMaster({ id }),
      );
      if (response.success && response.result && response.result.length > 0) {
        const orgData = response.result[0];

        // Set the first party details in the form
        form.setFieldValue("firstParty.name", orgData.name);
        form.setFieldValue("firstParty.entityType", orgData.details.entityType);
        form.setFieldValue("firstParty.regAddress", orgData.details.regAddress);
        form.setFieldValue("firstParty.type", "Entity"); // Set as Entity type

        console.log("First party details populated");
      }
    };
    getfirstPartyDetails();
  }, [form.businessUnit]);

  return (
    <div className="w-full flex flex-col my-4">
      <Group align="flex-start" spacing="md" mb="xl">
        <ThemeIcon variant="light" radius="xl" size={44}>
          <IconUsers size={20} />
        </ThemeIcon>

        <div>
          <Title order={4}>Contract Parties</Title>

          <Text size="sm" c="dimmed">
            Configure all parties participating in this agreement.
          </Text>
        </div>
      </Group>

      <Divider mb="xl" />
      <div className="flex flex-col justify-between my-2">
        {array.slice(0, addParty).map((partyName, index) => (
          <div
            key={partyName}
            className="rounded-lg
                      border
                      border-gray-200
                      p-6
                      mb-8
                      bg-white"
          >
            <AgreementParty
              agreementFormJson={agreementFormJson}
              dropDownNames={dropDownNames}
              form={form}
              partyName={partyName}
              setDropDownNames={setDropDownNames}
              dataRole={dataRole}
              setDataRole={setDataRole}
            />
          </div>
        ))}
      </div>
      <div
        style={{
          marginTop: 40,
          paddingTop: 24,
          borderTop: "1px solid #E9ECEF",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {uiConfigs.loading === loadingStates.LOADING ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <>
            <Button variant="outline" radius="md" onClick={savePrev}>
              Previous
            </Button>

            <Group>
              {addParty > 2 && (
                <Button
                  variant="light"
                  color="red"
                  radius="md"
                  onClick={() => setAddParty((p) => p - 1)}
                >
                  Remove Party
                </Button>
              )}

              {addParty < 20 && (
                <Button
                  variant="light"
                  radius="md"
                  onClick={() => setAddParty((p) => p + 1)}
                >
                  Add Party
                </Button>
              )}

              <Button radius="md" px={30} onClick={saveNext}>
                Next →
              </Button>
            </Group>
          </>
        )}
      </div>
    </div>
  );
};

export default AgreementForm3;
